/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SubscriptionUserControllerGetStateQueryResponse,
  SubscriptionUserControllerGetState401,
} from '../types/SubscriptionUserControllerGetState.ts';

function getSubscriptionUserGetStateUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/subscriptions` as const };
  return res;
}

/**
 * {@link /api/user/telegram/subscriptions}
 */
export async function subscriptionUserGetState(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SubscriptionUserControllerGetStateQueryResponse,
    ResponseErrorConfig<SubscriptionUserControllerGetState401>,
    unknown
  >({ method: 'GET', url: getSubscriptionUserGetStateUrl().url.toString(), ...requestConfig });
  return res.data;
}
